import React, { FC, useCallback, useEffect, useState } from 'react'
import { format } from 'date-fns'
import { State } from 'index'
import { useDispatch, useSelector } from 'react-redux'
import { getStocks } from 'reducks/stock/selectors'
import { updateModalHeader } from 'reducks/modal/operations'
import { getStoreRef } from 'reducks/auth/selectors'
import { IndividualScheduleCalendarContainer } from 'components/Calendar'
import { IndividualDeliveryScheduleEditCard } from 'components/Card'
import { StockType } from 'types/stock'
import { BreadType } from 'types/bread'
import { DaysOfWeek } from 'lib/daysOfWeek'
import { parseToDate } from 'lib/helper'
import { useIndividualDeliveryDates, useSaveIndividualDeliveryStock } from 'hooks/stock'
import { fetchStoreDeliveryBread } from 'reducks/storeDeliveryBread/operations'
import { getStoreDeliveryBread } from 'reducks/storeDeliveryBread/selectors'
import { initCalendar } from 'reducks/calendar/operations'
const daysOfWeek = new DaysOfWeek()
const allDaysOfWeek = daysOfWeek.getDaysOfWeek()

type Props = {
  bread: BreadType
}

const IndividualDeliveryScheduleModal: FC<Props> = (props) => {
  const { bread } = props

  const dispatch = useDispatch()
  const stocks: StockType[] = useSelector((state: State) => getStocks(state))
  const storeRef = useSelector((state: State) => getStoreRef(state))
  const storeDeliveryBread = useSelector((state: State) => getStoreDeliveryBread(state))

  const [activeDates, setActiveDates] = useState<Date[]>([])
  const [currentMonth, setCurrentMonth] = useState<Date>(new Date())
  const [settingDate, setSettingDate] = useState<Date | undefined>(undefined)
  const [individualSettingDates, setIndividualSettingDates] = useState<Date[]>([])
  const [stockList, setStockList] = useState<StockType[]>([])

  const handleCurrentMonth = useCallback((month: Date) => setCurrentMonth(month), [setCurrentMonth])
  const selectSettingDate = useCallback(
    (date: Date) => {
      setSettingDate(date)
      dispatch(updateModalHeader(`${format(date, 'M月d日')}の設定を変更`))
    },
    [setSettingDate, dispatch]
  )
  const backToSelectDate = useCallback(() => setSettingDate(undefined), [setSettingDate])

  const saveIndividualDeliveryStock = useSaveIndividualDeliveryStock(
    backToSelectDate,
    bread,
    settingDate,
    storeDeliveryBread,
    storeRef
  )

  // 対象商品のstocksをローカルのstateにセット
  useEffect(() => {
    if (!bread) return
    const stocksOfBread = stocks.filter((stock) => stock.bread_ref.id === bread.bread_ref?.id)
    setStockList([...stocksOfBread])
  }, [stocks, bread])

  // 事前予約の受渡可能日に設定済みの日付を取得
  useEffect(() => {
    const dates = stockList.map((stock) => parseToDate(stock.date))
    setActiveDates([...dates])
  }, [stockList])

  useEffect(() => {
    if (!storeRef || !bread.bread_ref) return
    dispatch(fetchStoreDeliveryBread(storeRef, bread.bread_ref))
  }, [storeRef, bread])

  useEffect(() => {
    dispatch(initCalendar())
  }, [])

  useIndividualDeliveryDates(storeDeliveryBread, stockList, setIndividualSettingDates)

  return (
    <>
      {typeof settingDate === 'undefined' ? (
        <IndividualScheduleCalendarContainer
          activeDates={activeDates}
          businessDays={allDaysOfWeek}
          currentMonth={currentMonth}
          handleCurrentMonth={handleCurrentMonth}
          individualSettingDates={individualSettingDates}
          selectSettingDate={selectSettingDate}
        />
      ) : (
        <IndividualDeliveryScheduleEditCard
          backToSelectDate={backToSelectDate}
          bread={bread}
          date={settingDate}
          saveIndividualDeliveryStock={saveIndividualDeliveryStock}
          stockList={stockList}
          storeDeliveryBread={storeDeliveryBread}
        />
      )}
    </>
  )
}

export default IndividualDeliveryScheduleModal
